document.addEventListener('DOMContentLoaded', function() {
  const medias = document.querySelectorAll('.media')
  const btnUp = document.querySelector('.product-media__gallery-button.up')
  const btnDown = document.querySelector('.product-media__gallery-button.down')
  const btnNext = document.querySelector('.product-media__featured-button.right')
  const btnPrev = document.querySelector('.product-media__featured-button.left')
  const featuredWrapper = document.querySelector('.product-media__featured-main-image')
  const magnifyButton = document.querySelector('.product-media__featured-magnify')
  const magnifyContainer = document.querySelector('.product-media__featured-magnify-container')
  const magnifyImage = document.querySelector('.product-media__featured-magnify-image img')

  const totalMedia = medias.length
  const visibleCount = 5
  let startIndex = 0
  let activeIndex = 0
  let visibleMedia = []

  // Function to update the counter based on active media
  function updateCounter() {
    const counterCurrent = document.querySelector('.product-media__featured-main-image-counter-current')
    if (counterCurrent) {
      counterCurrent.textContent = activeIndex + 1
    }
  }

  // Function to update the magnify icon visibility based on media type
  function updateMagnifyVisibility() {
    if (!magnifyButton) return
    
    const activeMedia = medias[activeIndex]
    if (!activeMedia) return

    const mediaType = activeMedia.dataset.mediaType
    
    if (mediaType === "video") {
      magnifyButton.style.display = 'none'
    } else {
      magnifyButton.style.display = 'block'
    }
  }

  // Function to find matching media by variant image URL
  function findMatchingMediaByVariantImage(variantImageUrl) {
    if (!variantImageUrl) return -1

    const variantFilename = variantImageUrl.split('/').pop().split('?')[0]
    const variantBaseFilename = variantFilename.replace(/_\d+x\d*\.(jpg|jpeg|png|webp|gif)/i, '.$1')
    
    for (let i = 0; i < medias.length; i++) {
      const media = medias[i]
      const mediaSrc = media.dataset.mediaSrc
      
      if (mediaSrc) {
        const mediaFilename = mediaSrc.split('/').pop().split('?')[0]
        const mediaBaseFilename = mediaFilename.replace(/_\d+x\d*\.(jpg|jpeg|png|webp|gif)/i, '.$1')
        
        // Exact filename match
        if (mediaFilename === variantFilename) {
          return i
        }
        
        // Base filename match (without size parameters)
        if (variantBaseFilename && mediaBaseFilename && mediaBaseFilename === variantBaseFilename) {
          return i
        }
        
        // Partial filename match
        if (mediaFilename.includes(variantBaseFilename.split('.')[0])) {
          return i
        }
      }
    }
    
    return -1
  }

  // Function to set active media by index
  function setActiveMedia(index) {
    if (index >= 0 && index < totalMedia) {
      activeIndex = index
      
      // Ensure the active media is visible in the gallery
      if (activeIndex < startIndex) {
        startIndex = activeIndex
      } else if (activeIndex >= startIndex + visibleCount) {
        startIndex = Math.max(0, activeIndex - visibleCount + 1)
      }
      
      updateVisibleMedia()
    }
  }

  // Function to update the featured media based on active media element
  function updateFeaturedMedia() {
    if (!featuredWrapper) return
    
    const activeMedia = medias[activeIndex]
    if (!activeMedia) return

    const mediaType = activeMedia.dataset.mediaType
    const mediaSrc = activeMedia.dataset.mediaSrc
    const mediaAlt = activeMedia.dataset.mediaAlt || 'Featured product media'

    // Check if we need to change the media type or if it's the same
    const existingMedia = featuredWrapper.querySelector('#featuredMedia')
    const existingType = existingMedia ? (existingMedia.tagName === 'VIDEO' ? 'video' : 'image') : null

    // If media type is the same, just update the source
    if (existingMedia && existingType === mediaType) {
      if (mediaType === "video") {
        existingMedia.src = mediaSrc
      } else {
        existingMedia.src = mediaSrc
        if (activeMedia.dataset.mediaSrcset) {
          existingMedia.srcset = activeMedia.dataset.mediaSrcset
        }
        existingMedia.alt = mediaAlt
        existingMedia.width = activeMedia.dataset.mediaWidth || 800
        existingMedia.height = activeMedia.dataset.mediaHeight || 800
      }
    } else {
      // Different media type, replace the element
      featuredWrapper.innerHTML = ""

      if (mediaType === "video") {
        const video = document.createElement("video")
        video.id = "featuredMedia"
        video.src = mediaSrc
        video.autoplay = true
        video.muted = true
        video.loop = true
        video.style.cssText = "width: 100%; height: 100%; object-fit: cover;"
        video.loading = "eager"
        featuredWrapper.appendChild(video)
      } else {
        const img = document.createElement("img")
        img.id = "featuredMedia"
        img.src = mediaSrc
        if (activeMedia.dataset.mediaSrcset) {
          img.srcset = activeMedia.dataset.mediaSrcset
        }
        img.alt = mediaAlt
        img.width = activeMedia.dataset.mediaWidth || 800
        img.height = activeMedia.dataset.mediaHeight || 800
        img.loading = "eager"
        img.fetchPriority = "high"
        featuredWrapper.appendChild(img)
      }
    }

    updateMagnifyVisibility()
  }

  // Handle magnify button click
  function handleMagnifyClick() {
    const activeMedia = medias[activeIndex]
    if (!activeMedia || !magnifyImage || !magnifyContainer) return

    const mediaType = activeMedia.dataset.mediaType
    
    if (mediaType === "image") {
      const mediaSrc = activeMedia.dataset.mediaSrc
      const mediaAlt = activeMedia.dataset.mediaAlt || 'Magnified product image'
      const mediaSrcset = activeMedia.dataset.mediaSrcset
      const mediaWidth = activeMedia.dataset.mediaWidth || 800
      const mediaHeight = activeMedia.dataset.mediaHeight || 800

      magnifyImage.src = mediaSrc
      magnifyImage.alt = mediaAlt
      magnifyImage.width = mediaWidth
      magnifyImage.height = mediaHeight
      
      if (mediaSrcset) {
        magnifyImage.srcset = mediaSrcset
      }

      magnifyContainer.style.display = 'block'
    }
  }

  // Initialize visible media array
  function updateVisibleMedia() {
    visibleMedia = Array.from(medias).slice(startIndex, startIndex + visibleCount)
    updateDisplay()
  }

  // Update display to show only visible media
  function updateDisplay() {
    // Hide all media first
    medias.forEach(media => {
      media.style.display = 'none'
      media.classList.remove('active-image')
    })

    // Show visible media
    visibleMedia.forEach((media, index) => {
      media.style.display = 'block'
      if (index === activeIndex - startIndex) {
        media.classList.add('active-image')
      }
    })

    // Show/hide navigation buttons
    if (totalMedia > visibleCount) {
      btnUp.style.display = 'block'
      btnDown.style.display = 'block'
    } else {
      btnUp.style.display = 'none'
      btnDown.style.display = 'none'
    }

    updateFeaturedMedia()
    updateCounter()
  }

  // Handle media click
  medias.forEach((media, idx) => {
    media.addEventListener('click', function() {
      activeIndex = idx
      updateDisplay()
      
      // Dispatch event to sync variant selection with media change
      const mediaSelectedEvent = new CustomEvent('mediaSelected', {
        detail: {
          mediaIndex: idx,
          mediaSrc: media.dataset.mediaSrc
        }
      });
      document.dispatchEvent(mediaSelectedEvent);
    })
  })

  // Next media function
  function nextMedia() {
    if (activeIndex < totalMedia - 1) {
      activeIndex++
      
      if (activeIndex >= startIndex + visibleCount && startIndex + visibleCount < totalMedia) {
        startIndex++
        updateVisibleMedia()
      } else {
        updateDisplay()
      }
    } else {
      activeIndex = 0
      startIndex = 0
      updateVisibleMedia()
    }
    
    // Dispatch event to sync variant selection
    const activeMedia = medias[activeIndex];
    if (activeMedia) {
      const mediaSelectedEvent = new CustomEvent('mediaSelected', {
        detail: {
          mediaIndex: activeIndex,
          mediaSrc: activeMedia.dataset.mediaSrc
        }
      });
      document.dispatchEvent(mediaSelectedEvent);
    }
  }

  // Previous media function
  function prevMedia() {
    if (activeIndex > 0) {
      activeIndex--
      
      if (activeIndex < startIndex && startIndex > 0) {
        startIndex--
        updateVisibleMedia()
      } else {
        updateDisplay()
      }
    } else {
      activeIndex = totalMedia - 1
      startIndex = Math.max(0, totalMedia - visibleCount)
      updateVisibleMedia()
    }
    
    // Dispatch event to sync variant selection
    const activeMedia = medias[activeIndex];
    if (activeMedia) {
      const mediaSelectedEvent = new CustomEvent('mediaSelected', {
        detail: {
          mediaIndex: activeIndex,
          mediaSrc: activeMedia.dataset.mediaSrc
        }
      });
      document.dispatchEvent(mediaSelectedEvent);
    }
  }

  // Button event listeners
  if (btnDown) btnDown.addEventListener('click', nextMedia)
  if (btnUp) btnUp.addEventListener('click', prevMedia)
  if (btnNext) btnNext.addEventListener('click', nextMedia)
  if (btnPrev) btnPrev.addEventListener('click', prevMedia)

  // Magnify button event listener
  if (magnifyButton) {
    magnifyButton.addEventListener('click', handleMagnifyClick)
  }

  // Swipe functionality for mobile
  function isMobileDevice() {
    return window.innerWidth <= 768 // Match mobile media query breakpoint
  }

  let touchStartX = 0
  let touchStartY = 0
  let touchEndX = 0
  let touchEndY = 0
  const minSwipeDistance = 50 // Minimum distance in pixels to trigger a swipe

  function handleTouchStart(e) {
    if (!isMobileDevice() || !featuredWrapper) return
    
    // Don't allow swipe if magnify modal is open
    if (magnifyContainer && magnifyContainer.style.display === 'block') return
    
    const touch = e.touches[0]
    touchStartX = touch.clientX
    touchStartY = touch.clientY
  }

  function handleTouchMove(e) {
    // Prevent default scrolling while swiping on the featured image
    if (!isMobileDevice() || !featuredWrapper) return
    
    if (magnifyContainer && magnifyContainer.style.display === 'block') return
    
    // Only prevent default if we're actually swiping horizontally
    const touch = e.touches[0]
    const deltaX = Math.abs(touch.clientX - touchStartX)
    const deltaY = Math.abs(touch.clientY - touchStartY)
    
    // If horizontal swipe is more significant than vertical, prevent default
    if (deltaX > deltaY && deltaX > 10) {
      e.preventDefault()
    }
  }

  function handleTouchEnd(e) {
    if (!isMobileDevice() || !featuredWrapper) return
    
    // Don't allow swipe if magnify modal is open
    if (magnifyContainer && magnifyContainer.style.display === 'block') return
    
    const touch = e.changedTouches[0]
    touchEndX = touch.clientX
    touchEndY = touch.clientY
    
    const deltaX = touchEndX - touchStartX
    const deltaY = touchEndY - touchStartY
    const absDeltaX = Math.abs(deltaX)
    const absDeltaY = Math.abs(deltaY)
    
    // Check if it's a horizontal swipe (more horizontal than vertical movement)
    if (absDeltaX > absDeltaY && absDeltaX > minSwipeDistance) {
      if (deltaX > 0) {
        // Swipe right - go to previous media
        prevMedia()
      } else {
        // Swipe left - go to next media
        nextMedia()
      }
    }
  }

  // Add touch event listeners to the featured media container
  if (featuredWrapper) {
    featuredWrapper.addEventListener('touchstart', handleTouchStart, { passive: true })
    featuredWrapper.addEventListener('touchmove', handleTouchMove, { passive: false })
    featuredWrapper.addEventListener('touchend', handleTouchEnd, { passive: true })
  }

  // Close magnify modal when clicking on the container
  if (magnifyContainer) {
    magnifyContainer.addEventListener('click', function() {
      magnifyContainer.style.display = 'none'
    })
  }

  // Listen for variant selection from main product JS to update media
  document.addEventListener('variantSelected', function(e) {
    const variantImage = e.detail.variantImage
    
    if (variantImage) {
      const matchingMediaIndex = findMatchingMediaByVariantImage(variantImage)
      
      if (matchingMediaIndex !== -1) {
        setActiveMedia(matchingMediaIndex)
      }
    }
  })

  // Make setActiveMedia available globally for main product JS
  window.productMediaSetActiveMedia = setActiveMedia
  window.productMediaFindMatchingMedia = findMatchingMediaByVariantImage

  // Initialize
  updateVisibleMedia()
})